import type { AccountingSummary } from "@/utils/accounting";
import { formatCOP } from "@/utils/format";

const ChannelPanel = ({ summary }: { summary: AccountingSummary }) => {
  const rows = [
    { label: "Ventas directas (punto / internet)", value: summary.directSales, icon: "ri-store-2-line", tone: "text-foreground-950" },
    { label: "Ventas a asesores (compras)", value: summary.advisorPurchases, icon: "ri-shopping-bag-3-line", tone: "text-foreground-950" },
    { label: "Consignaciones pagadas", value: summary.consignmentPaid, icon: "ri-hand-coin-line", tone: "text-accent-200" },
  ];

  return (
    <div className="glass-panel rounded-lg p-4 md:p-5">
      <div className="flex items-center gap-2 mb-1">
        <span className="w-8 h-8 rounded-md bg-accent-500/20 text-accent-200 flex items-center justify-center">
          <i className="ri-bar-chart-box-line" />
        </span>
        <h3 className="editable-title text-base font-bold">Ingresos reconocidos por canal</h3>
      </div>
      <p className="text-[11px] text-foreground-500 mb-4">
        Solo cuenta lo efectivamente vendido o pagado.
      </p>

      <div className="space-y-2">
        {rows.map((r) => (
          <div
            key={r.label}
            className="flex items-center justify-between rounded-md bg-background-200/40 border border-background-300/40 px-3 py-2"
          >
            <span className="flex items-center gap-2 text-xs text-foreground-600">
              <i className={`${r.icon} text-accent-300`} /> {r.label}
            </span>
            <span className={`text-sm font-bold ${r.tone}`}>{formatCOP(r.value)}</span>
          </div>
        ))}
      </div>

      <div className="mt-4 flex items-center justify-between rounded-md bg-background-200/40 border border-accent-500/20 px-3 py-3">
        <span className="text-xs font-semibold text-foreground-600">Total ingresos reconocidos</span>
        <span className="text-base font-heading font-extrabold text-foreground-950">
          {formatCOP(summary.recognizedIncome)}
        </span>
      </div>

      <div className="mt-3 flex items-center justify-between text-[11px] text-foreground-500">
        <span>Gastos y caja menor registrados</span>
        <span className="font-semibold text-primary-200">{formatCOP(summary.expensesTotal)}</span>
      </div>
    </div>
  );
};

export default ChannelPanel;